import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import 'app/styles/components/related-facilities-table.css';
import { EntityParams } from 'app/models/entity-params';
import { getEntities, getEntity } from 'app/state/ducks/entities/selectors';
import { loadEntities, loadOneEntity } from 'app/state/ducks/entities/thunks';
import { roleLabels } from '../entity-profile/components/entity-profile-form/roles-section';
import { EntityRole, ThirdPartyRoles } from 'app/models/entity-profile-params';

export default function EntityServiceProvidersTable() {
  const dispatch = useDispatch();
  const { entityId, status } = useParams();

  const entity: EntityParams = useSelector(getEntity);
  const entities: EntityParams[] = useSelector(getEntities);
  const thirdPartyProviders = entity?.thirdPartyProviders ?? [];

  useEffect(() => {
    dispatch(loadOneEntity(entityId ?? '', status ?? 'Inactive'));
    dispatch(loadEntities());
  }, []);


  const tableHeaders = [
    { key: 'entity', label: 'Entity' },
    { key: 'role', label: 'Service Entity Type' }
  ];

  return (
    <div className='related-facilities-container'>
      {thirdPartyProviders.length > 0 && (
        <div className='related-facilities-table'>
          {tableHeaders.map(header => (
            <div key={header.key} className='column'>
              <div className='column-header'>{header.label}</div>
              {thirdPartyProviders.map((provider, i) => {
                const serviceEntity = entities.find(e => e.id === provider.thirdPartyProfile?.id);
                const entityName = serviceEntity?.entityName ?? '—';
                // AgentRole is a delivery-only role (ADR_LOS-026) with no
                // EntityRole counterpart, so it can't index roleLabels.
                const roleLabel =
                  provider.thirdPartyRole === ThirdPartyRoles.AgentRole
                    ? 'Agent'
                    : roleLabels[provider.thirdPartyRole as unknown as EntityRole] ?? provider.thirdPartyRole;

                return (
                  <div
                    key={`cell_${i}_${header.key}`}
                    className='column-data clickable-row'
                    onClick={() => console.log('Clicked on:', provider)}
                  >
                    {header.key === 'entity' ? entityName : roleLabel}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
